import Skeleton from "@oxygen/core/lib/SkeletonLoader/Skeleton";
import getThemeClasses from "@oxygen/theme";
import React from "react";

const containerClasses = getThemeClasses(`
  bg-dimWhite;
  width-full;
`);
export const HomeBannerLoader = () => {
  return (
    <div className={containerClasses}>
      <Skeleton height={356} id="HomePageBannerLoader">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="214" />
        <rect x="71" y="230" rx="2" ry="2" width="60%" height="18" />
        <rect x="16" y="264" rx="2" ry="2" width="91%" height="48" />
        <rect x="84" y="328" rx="2" ry="2" width="53%" height="12" />
      </Skeleton>
    </div>
  );
};
